import React, { useEffect, useState } from 'react'
import api from '../../controller/api'
import Button from '@mui/material/Button';
import { toast, Toaster } from "sonner"
import { useNavigate } from "react-router-dom"
import Loading from "../../components/Loading"
import { CategoryData } from "../../components/Tables"

export default function CategoryList() {
    const [category, setCategory] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    const navigate = useNavigate()

    const handleStatus = async (id) => {
        try {
            await api.put("/category/ChangeStatus", { id })
            toast.success("Status updated")
            getCategory()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        }
    }
    const getCategory = async () => {
        try {
            const { data: res } = await api.get("/category/list")
            setCategory(res.data.reverse())
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    const deleteCategory = async (id) => {
        try {
            setPageLoading(true)
            await api.delete(`/category/delete/${id}`)
            toast.success("Category deleted")
            getCategory()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setPageLoading(false)
        }
    }

    useEffect(() => {
        setPageLoading(true)
        getCategory()
    }, [])

    if (pageLoading) return <Loading />

    return (
        <div className='table-data'>
            <Toaster richColors position="top-center" />
            <div className='manage'>
                <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                    Category List
                    <Button variant="contained" onClick={() => navigate("/dashboard/category-create")}>Add Category</Button>
                </h2>
                <CategoryData handleStatus={handleStatus} deleteCategory={deleteCategory} category={category} />
            </div>
        </div>
    )
}
